export default __webpack_public_path__ + "static/media/dashboard.ea6adf8f.svg";